<template>
  <div class="chat-item-text">
    <div class="d-flex flex-row">
        <!--
        <user-mini-avatar
          :user-id="message.senderUserId"
          :show-name="true"
          size="normal"
          style="align-self: center: width: 50px;" />
        -->

        <template v-if="!groupable">
          <div
            v-if="message.senderUserId !== myUserId"
            class="avatar"
            :style="{ backgroundImage: 'url(&quot;' + $options.filters.defaultUserPic(otherUserStatus.profilePic) + '&quot;)' }">
          </div>
          <div
            v-else
            class="avatar"
            :style="{ backgroundImage: 'url(&quot;' + $options.filters.defaultUserPic(myUserStatus.profilePic) + '&quot;)' }">
          </div>
        </template>
        <div v-else style="width: 32px" />

        <div class="ml-2" style="flex: 1">
          <div v-if="!groupable">
            <strong style="color: var(--blue)">
              {{ message.senderUserId === myUserId ? myUserStatus.displayName : otherUserStatus.displayName }}
            </strong>
            <span class="small text-muted">{{message.createdAt|fromNow}}</span>
          </div>

          <p style="font-size: 11pt" class="m-0">
            {{message.message}}
            <i v-if="!message.unread" class="el-icon-check" style="color: #AAA"></i>
          </p>
        </div>

        <div style="align-self: flex-end; margin-right: 6px;"
          @mouseover="onMouseoverEllipsisButton">

          <template v-if="ellipsisButtonActive">

            <ellipsis-button
              placement="right"
              heading="Message"
              width="180"
              :show-options="['slot']">

              <!--
              <el-button
                v-if="!message.unread && message.senderUserId !== myUserId"
                class="btn-block ml-0"
                size="mini"
                @click="onMarkMessageAsUnseen(message)">
                Mark as unseen
              </el-button>
              -->

              <el-button
                title="Reply"
                class="btn-block ml-0"
                size="mini"
                :disabled="true"
                @click="onReplyToMessage(message)">
                <font-awesome-icon icon="reply" class="taskicon" />
                Reply
              </el-button>

              <template v-if="message.senderUserId === $models.user.defaultUserId">
                <el-button
                  title="Edit"
                  class="btn-block ml-0"
                  size="mini"
                  @click.prevent="onEditExistingMessage(message)">
                  <font-awesome-icon icon="pen-square" class="taskicon" />
                  Edit
                </el-button>

                <el-button
                  title="Edit"
                  class="btn-block ml-0"
                  size="mini"
                  type="danger"
                  @click.prevent="onDeleteMessage(message.$id)">
                  <font-awesome-icon icon="trash" class="taskicon" />
                  Delete
                </el-button>
              </template>
            </ellipsis-button>
          </template>
          <template v-else>
            <el-button class="ellipsis-button__button">
              <font-awesome-icon size="sm" :icon="['fas', 'ellipsis-v']" color="#687a8c"/>
            </el-button>
          </template>
        </div>
      </div>

      <chat-item-task
        v-if="message.type === 'TASK'"
        :message="message"
        ref="task" />

      <chat-item-tasklist
        v-if="message.type === 'TASKLIST' || message.type === 'TIME_BASED_TASKLIIST'"
        :message="message" />

      <chat-item-sequence
        v-if="message.type === 'SEQUENCE'"
        :message="message" />

  </div>
</template>

<script>
import * as ChatItemsModule from './'

const ChatItemsList = {}
for ( let chatItemName in ChatItemsModule ) { // Iterate over Module
  ChatItemsList[ chatItemName ] = ChatItemsModule[ chatItemName ]
}

// TODO: Allow to reply to messages
// TODO: Double checkmark for read
// xTODO: Group messages

export default {
  props: {
    message: { required: true },
    otherUserStatus: { required: true },
    myUserStatus: { required: true },
    contactId: { required: true },
    groupable: { defualt: false },
  },
  data: () => ({
    ellipsisButtonActive: false,
  }),
  computed: {
    myUserId() {
      return this.$models.user.defaultUserId;
    },
  },
  methods: {
    onMarkMessageAsUnseen(message, unread = true) {
      message.update({ unread })
    },

    onReplyToMessage(message) {
      console.warn("NOT_IMPLEMENTED");
    },

    onEditExistingMessage( message ) {
      console.log("message", message)

      this.$prompt('', 'Please edit message', {
        inputValue: message.message,
        closeOnClickModal: false,
      }).then(({ value }) => {
        this.$models.userMsgInbox
          .with({ uid: this.contactId })
          .update( message.$id, { message: value })
      }).catch(() => {});
    },

    onDeleteMessage( messageId ) {
      this.$api.contact_delete_message({
        receiverUserId: this.contactId,
        messageId
      });
    },

    onMouseoverEllipsisButton() {
      this.ellipsisButtonActive = true;
    },

    focus() {
      if ( this.$refs.task ) {
        this.$refs.task.focus();
      }
    },
  },
  components: {
    ...ChatItemsList
  }
};
</script>

<style>
.chat-item-text .ellipsis-button__button {
  /*border: none;*/
}
</style>
